import { noticeDismissDays } from "src/utils/notice-dismissal";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const priorityColor = {
  HIGH: "error.main",
  NORMAL: "primary.main",
  LOW: "text.secondary",
};

export const NoticeModal = (props) => {
  const { notice, onClose, onDismiss } = props;

  if (!notice) return null;

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          borderTop: 4,
          borderColor: priorityColor[notice.priority] || "primary.main",
        }}
      >
        {notice.title}
      </DialogTitle>
      <DialogContent dividers>
        <Typography
          variant="body2"
          component="div"
          sx={{ lineHeight: 1.8 }}
          dangerouslySetInnerHTML={{ __html: notice.content }}
        />
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", rowGap: 0.5 }}>
        <Button
          onClick={() => onDismiss(noticeDismissDays(notice))}
          size="small"
          color="inherit"
        >
          {noticeDismissDays(notice) === 7 ? "1주일간 안보기" : "1일간 안보기"}
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          size="small"
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};
